import { render, staticRenderFns } from "./InvalidSiteAddressList.vue?vue&type=template&id=d23c1672&scoped=true"
import script from "./InvalidSiteAddressList.vue?vue&type=script&lang=js"
export * from "./InvalidSiteAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23c1672",
  null
  
)

export default component.exports